import { ReactNode } from 'react';
import { Image } from '@/components/generic';
import { cn } from '@/lib/utils';

interface OptionProps {
  classTitle?: string;
  title: string;
  color?: string;
  image?: string;
  stroke?: boolean;
  children: ReactNode;
}
export const Option = ({
  classTitle,
  title,
  color,
  image,
  stroke,
  children,
}: OptionProps) => (
  <div
    className={cn(
      `flex items-center`,
      stroke
        ? 'min-h-[4rem] px-4 py-4 border border-s-subtle rounded-xl'
        : 'min-h-[3.5rem] border-t border-s-border',
    )}
  >
    <div
      className={cn(
        `flex items-center w-20 mr-6 text-sub-title-1 text-t-secondary max-xl:mr-3`,
        classTitle || '',
      )}
    >
      {image ? (
        <Image className='crypto-logo w-6' src={image} alt='' />
      ) : (
        <>
          <div
            className={cn(
              'shrink-0 w-3 h-3 mr-2 rounded',
              color || 'bg-primary-05',
            )}
          />
          <span className='text-body-2'>{title}</span>
        </>
      )}
    </div>
    <div className='flex items-center grow text-body-2 text-t-primary font-bold  '>
      {children}
    </div>
  </div>
);
